import _styled, { default as _styled2, default as _styled3 } from "styled-components";
import React from "react";
import type { DownloadWarningView } from "~/features/downloads/adapter";
import { useDownloads } from "~/features/downloads/context";
import { SanityRichText } from "~/features/sanity/rich-text";
import { Icon } from "~/features/ui/icon";
import { getThemeStyle } from "~/features/ui/get-theme-style";
import { Wrap } from "~/features/ui/wrap";
import { hasItems } from "~/features/app/utils";
import Close from "~/public/icons/close.svg";
import WarningIcon from "~/public/icons/warning.svg";
function Warning(props: {
  warning: DownloadWarningView;
}) {
  const {
    leftSlug,
    operator,
    rightSlug,
    message
  } = props.warning;
  const {
    activeFirmwareVersion,
    activeHardwareVersion
  } = useDownloads();
  const [isDismissed, setIsDismissed] = React.useState(false);
  const themeStyle = getThemeStyle({
    mode: "light"
  });
  if (isDismissed) {
    return null;
  }
  const leftActive = leftSlug === activeHardwareVersion || leftSlug === activeFirmwareVersion;
  const rightActive = rightSlug === activeHardwareVersion || rightSlug === activeFirmwareVersion;
  const matches = operator === "or" ? leftActive || rightActive : leftActive && rightActive;
  if (!matches) {
    return null;
  }
  return <_StyledDiv $_css={[{
    "borderBottomWidth": "1px",
    "padding": "1.6rem",
    "@media (min-width: 1024px)": {
      "padding": "2.4rem"
    }
  }, themeStyle.border]}>
      <_StyledDiv2>
        <Icon icon={WarningIcon} />
        <_StyledDiv3>
          <SanityRichText value={message} />
        </_StyledDiv3>
        <button aria-label="Close" onClick={() => setIsDismissed(true)}>
          <Icon icon={Close} />
        </button>
      </_StyledDiv2>
    </_StyledDiv>;
}
export function Warnings(props: {
  warnings: DownloadWarningView[];
}) {
  const {
    warnings
  } = props;
  if (!hasItems(warnings)) {
    return null;
  }
  return <Wrap mode="light">
      {warnings.map((warning, idx) => <Warning key={idx} warning={warning} />)}
    </Wrap>;
}
var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  componentId: "sc-sf-17og8gg-0"
})`${p => p.$_css}`;
var _StyledDiv2 = _styled2("div").withConfig({
  componentId: "sc-sf-17og8gg-1"
})({
  "position": "relative",
  "zIndex": "10",
  "display": "flex",
  "alignItems": "flex-start",
  "columnGap": "1.6rem",
  "borderRadius": "4px",
  "backgroundColor": "var(--color-functional-warning)",
  "padding": "1.6rem",
  "@media (min-width: 1024px)": {
    "alignItems": "center",
    "columnGap": "2.4rem",
    "padding": "2.4rem"
  }
});
var _StyledDiv3 = /*#__PURE__*/_styled3("div").withConfig({
  displayName: "warnings___StyledDiv3",
  componentId: "sc-16m678c-0"
})({
  "flex": "1 1 0%",
  "fontSize": "1.4rem",
  "lineHeight": "1.5",
  "letterSpacing": "0.014000000000000002rem",
  "fontWeight": "400",
  "@media (min-width: 1024px)": {
    "fontSize": "1.4rem",
    "lineHeight": "1.5",
    "letterSpacing": "0.014000000000000002rem",
    "fontWeight": "400"
  }
});